import { T } from '../../styles/tokens';

export interface Level {
  name: string;
  label: string;
  icon: string;
  color: string;
  min: number;
}

interface LevelProgressBarProps {
  levels: Level[];
  currentLevel: Level;
  nextLevel: Level | null;
  progress: number;
}

export function LevelProgressBar({ levels, currentLevel, nextLevel, progress }: LevelProgressBarProps) {
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 18 }}>{currentLevel.icon}</span>
          <span style={{ fontSize: 14, fontWeight: 700, color: currentLevel.color }}>
            {currentLevel.label}
          </span>
        </div>
        {nextLevel && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>Próximo:</span>
            <span style={{ fontSize: 14 }}>{nextLevel.icon}</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: nextLevel.color }}>{nextLevel.label}</span>
          </div>
        )}
      </div>

      {/* Barra de nível */}
      <div style={{ display: 'flex', gap: 3, marginBottom: 8 }}>
        {levels.map((l, i) => {
          const isActive = i <= levels.indexOf(currentLevel);
          const isCurrent = l.name === currentLevel.name;
          return (
            <div key={l.name} style={{ flex: 1, position: 'relative' }}>
              <div style={{
                height: 8, borderRadius: 4,
                background: isActive
                  ? isCurrent
                    ? `linear-gradient(90deg, ${l.color}, ${l.color}80)`
                    : l.color
                  : T.bgActive,
                transition: 'all 0.5s',
                ...(isCurrent && nextLevel ? { width: `${Math.min(progress, 100)}%` } : {}),
              }} />
            </div>
          );
        })}
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {levels.map((l) => (
          <div key={l.name} style={{
            fontSize: 10, color: l.name === currentLevel.name ? l.color : 'var(--text-dim)',
            fontWeight: l.name === currentLevel.name ? 700 : 500, textAlign: 'center', flex: 1,
          }}>
            {l.icon} {l.min}+
          </div>
        ))}
      </div>
    </>
  );
}
